export default "__VITE_ASSET__D$q8DozW__"